// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"MainHeader_mainHeader__2_ywg","mainCaption":"MainHeader_mainCaption__2Hs0h","imgWrapper":"MainHeader_imgWrapper__x_nlP"};